import db from './index.js'

export async function getAllUsers() {
    return await db.users.toArray()
}

export async function getUser(userId) {
    return await db.users.get(userId)
}

export async function addUser(user) {
    await db.users.put(user)
}

export async function putUsers(usersArray) {
    if (usersArray && usersArray.length > 0) {
        await db.users.bulkPut(usersArray)
    }
}

export async function updateUser(user) {
    await db.users.put(user)
}

export async function updateUserOnlineStatus(userId, status, last_seen) {
    await db.users.update(userId, {
        onlineStatus: { status, last_seen },
    })
}

export async function deleteUser(userId) {
    await db.users.delete(userId)
}
